module.exports = __webpack_public_path__ + "img/active.c57de0b0.svg";